import { render, staticRenderFns } from "./bind-tester-dialog.vue?vue&type=template&id=bc144698&scoped=true"
import script from "./bind-tester-dialog.vue?vue&type=script&lang=js"
export * from "./bind-tester-dialog.vue?vue&type=script&lang=js"
import style0 from "./bind-tester-dialog.vue?vue&type=style&index=0&id=bc144698&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc144698",
  null
  
)

export default component.exports